import {
  useErrorToastWithAudio,
  UseErrorToastWithAudioArgs,
} from "shared/hooks/useErrorToastWithAudio";

export function useCheckAlreadyCompletedToast() {
  const { showToastAndPlayError } = useErrorToastWithAudio({
    errorToastId: "task_already_completed_toast",
  });

  const showCheckAlreadyCompletedToast = (options?: UseErrorToastWithAudioArgs) => {
    showToastAndPlayError({
      ...options,
      title: "flows.inventory.hooks.use-check-already-completed-toast.title",
    });
  };

  return { showCheckAlreadyCompletedToast };
}
